/** 默认监控配置对象 */
export const DefaultMonitorOptions = {
  logUpload: {
    projectCode: "idt-monitor",
    enable: false,
    environment: "PORD",
    protocol: "https",
    intervalCollect: {
      enable: false,
      collectTime: 60,
    },
  },
  logRecord: {
    dbName: "Idt-Monitor-DB",
  },
  errorCatch: {
    enable: true,
    useLog: true,
    directUpload: false,
    debug: false,
  },
};
